import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Labeled cluster of related fields — plan/49.
 * `section` = page-level group (Identity, Phonebook); `sub` = inner cluster (Phones, Tax).
 */
export function FieldGroup(props: {
  title: string;
  children: ReactNode;
  className?: string;
  level?: "section" | "sub";
  /** Optional quiet hint under the title */
  description?: string;
}) {
  const level = props.level ?? "section";
  return (
    <section
      className={cn(
        level === "section" ? "mt-8 space-y-3" : "space-y-2",
        props.className,
      )}
    >
      <div className="space-y-0.5">
        {level === "section" ? (
          <h2 className="m-0 text-xs font-semibold uppercase tracking-wider text-[var(--color-muted)]">
            {props.title}
          </h2>
        ) : (
          <h3 className="m-0 text-sm font-medium text-[var(--color-foreground)]">
            {props.title}
          </h3>
        )}
        {props.description ? (
          <p className="m-0 text-xs text-[var(--color-muted)]">
            {props.description}
          </p>
        ) : null}
      </div>
      {props.children}
    </section>
  );
}
